<mat-expansion-panel
  #paymentTypesPanel
  class="checkout-payment-types-expansion-panel"
  aria-label="Select a payment method"
>
  <mat-expansion-panel-header collapsedHeight="3rem" expandedHeight="3rem">
    <mat-panel-title>
      <payment-type
        [paymentType]="selectedPaymentType"
        [alternativeIconView]="true"
        [showCampaign]="false"
        [attr.aria-label]="selectedPaymentType?.title"
      ></payment-type>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <p *ngIf="showCardPromoMessage" class="checkout-payment-types-instructions">
    {{ 'pay_online_with_your_card' | translate }}
    <br />
    {{ 'earn_' | translate }} {{ firstOrderCardPoints }}
    {{ 'points_and_dont_worry_about_carrying_cash_anymore' | translate }}
  </p>
  <payment-type
    *ngFor="let paymentType of paymentTypes"
    matRipple
    class="hoverable checkout-payment-types-payment-type"
    [class.checkout-payment-types-payment-type-disabled]="paymentType?.card?.expired"
    [paymentType]="paymentType"
    (click)="onPaymentSelect(paymentType)"
    (keydown.enter)="onPaymentSelect(paymentType)"
    [showCampaign]="true"
    tabindex="0"
    role="button"
    [attr.aria-label]="paymentType.title"
  >
  </payment-type>
</mat-expansion-panel>
